var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container flex-wrap flex-center"},[_vm._v(" 宁波高专建设监理有限公司(c)2023-2028 "),_c('Divider',{attrs:{"type":"verticle"}}),_vm._v(" 联系电话 15991913205 ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }